<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Production Planning/ ສາຂາ
            
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid==2">
        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂສາຂາ">
         <div class="columns" >
            <div class="column">
              <h3 class="title">ເພິ່ມ/ ແກ້ໄຂສາຂາ</h3>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field label="ຊື່ສາຂາ">
                    <b-input v-model.trim="branchname"> </b-input>
                  </b-field>
                </div>
                 <div class="column">
                  <b-field label="ຊື່ສາຂາ(EN)">
                    <b-input v-model.trim="branchenname"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ປະເທດ">
                    <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedCountry"
                    label="NAME"
                    track-by="ID"
                    :options="countryList"
                    @input="onCountrySelected"
                  >
                  </Multiselect>
                  </b-field>
                  
                </div>
                <div class="column">
                  <b-field label="ແຂວງ">
                    <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedProvince"
                    label="NAME"
                    track-by="ID"
                    :options="provinceList"
                  >
                  </Multiselect>
                  </b-field>
                </div>
                 <div class="column">
                  <b-field label="ຜູ້ຮັບຜິດຊອບ">
                    <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedUser"
                    label="FULLNAME"
                    track-by="USERNAME"
                    :options="userList"
                  >
                  </Multiselect>
                  </b-field>
                </div>
              </div>
             
              <b-field label="" style="float: right">
                <b-field v-if="saveAction">
                  <button class="button is-info" @click="saveBranch">
                    ບັນທຶກ
                  </button>
                </b-field>
                <b-field v-if="updateAction">
                  <div class="columns">
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-primary"
                          @click="updateBranch"
                        >
                          ແກ້ໄຂ
                        </button>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-info"
                          @click="openSaveBranchForm"
                        >
                          ຟອມເພີ່ມສາຂາ
                        </button>
                      </b-field>
                    </div>
                  </div>
                </b-field>
              </b-field>
            </div>
          </div>

        </b-tab-item>

        <b-tab-item label="ສາຂາ ເປີດໃຊ້ງານ">
          <div class="columns">
            <div class="column">
              <b-field label="ສາຂາ ເປີດໃຊ້ງານ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ສາຂາ/ ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ສາຂາ(EN)
                      </th>

                      <th class="has-text-left " width="15%">
                        ປະເທດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງທີ່ຮັບຜິດຊອບ
                      </th>
                      <th class="has-text-left " width="30%">
                        ຜູ້ຮັບຜິດຊອບ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activebranches"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.NAME }} <br> {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.ENNAME }}
                      </td>
                      <td>
                        {{ data.COUNTRYNAME }}
                      </td>
                      <td>
                          <span v-html="data.BRANCHPROVINCE"></span>
                          <Multiselect
                            placeholder="ເພີ່ມແຂວງ"
                            v-model.trim="data.selectedBranchProvince"
                            label="NAME"
                            track-by="ID"
                            :options="branchProvinceList"
                            @input="onSelectBranchProvince(data.ID,data.selectedBranchProvince)"
                          >
                          </Multiselect>
                 
                      </td>
                      <td>
                        {{ data.FULLNAME }} <br> {{data.USERNAME}}
                      </td>
                     
                      <td class="has-text-centered">
                          <b-field group>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  updateBranchForm(
                                    data.ID,
                                    data.NAME,
                                    data.ENNAME,
                                    data.COUNTRYID,
                                    data.COUNTRYNAME,
                                    data.PROVINCEID,
                                    data.PROVINCENAME,
                                    data.FULLNAME,
                                    data.USERNAME
                                  )"
                                >ແກ້ໄຂ
                              </b-button>
                            </b-field>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="
                                  changeBranchSataus(data.ID,0)"
                                >ປິດໃຊ້ງານ
                              </b-button>
                            </b-field>
                          </b-field>
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        
        <b-tab-item label="ສາຂາ ທີ່ຖືກປິດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ສາຂາ ທີ່ຖືກປິດ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ສາຂາ
                      </th>
                      <th class="has-text-left " width="15%">
                        ສາຂາ(EN)
                      </th>

                      <th class="has-text-left " width="15%">
                        ປະເທດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="30%">
                        ຜູ້ຮັບຜິດຊອບ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in inactivebranches"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.NAME }}
                      </td>
                      <td>
                        {{ data.ENNAME }}
                      </td>
                      <td>
                        {{ data.COUNTRYNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        <b-field>
                              <b-button class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              changeBranchSataus(data.ID,1)"
                            >ເປີດໃຊ້ງານ
                          </b-button>
                        </b-field>
                      </td>
                      
                      
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
    roleid: null,
    userName: null,
    selectedCountry: null,
    countryList: [],
    isProvinceSelected: false,
    selectedProvince: null,
    provinceList:  [],
    selectedUser: null,
    userList: [],
    

    activebranches: [],
    inactivebranches: [],
    branchid: null,
    oldbranchname: null,
    branchname: null,
    oldbranchenname: null,
    branchenname: null,
    countryid: null,
    provinceid: null,
    oldprovinceid: null,
    responseusername: null,
    oldresponseusername: null,

    activeTab: 1,
    saveAction: true,
    updateAction: false,
    adddataform: true,
    updatedataform: false,

    selectedBranchProvince: null,
    branchProvinceList: [],
    
  };
  },
  methods: {
    getCountry() {
      RestAPI.getCountry()
        .then(res => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.countryList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getResponseUser() {
      RestAPI.getResponseUser(3)
        .then(res => {
          // console.log("con: "+ JSON.stringify(res.data))
          if(this.updateAction==true){
            this.userList = res.data;
            this.userList.push(this.selectedUser)
          }
         
          this.userList = res.data;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onCountrySelected() {
      // this.isProvinceSelected = false;
      console.log("selected country: "+ JSON.stringify(this.selectedCountry))
      console.log("selected country ID: "+ JSON.stringify(this.selectedCountry.ID))
      
      this.getProvince();
      this.selectedProvince= null;
      
    },
    getProvince(){
      RestAPI.getProvincebyCountry(this.selectedCountry.ID)
        .then(res => {
          // console.log("country selected...")
          this.provinceList = res.data;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getAllProvince(){
      RestAPI.getAllProvince()
        .then(res => {
          this.branchProvinceList = res.data;
          //  console.log("branchProvinceList: " + JSON.stringify(this.branchProvinceList))
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onSelectBranchProvince(branchid, provinceid){
      var params = {
        branchid: branchid,
        provinceid : provinceid.ID,
        username: this.username
      };

      // console.log("pa: " + JSON.stringify(params))
     
      RestAPI.addProvinceToBranch(params)
        .then(() => {
          this.countryid = null;
          this.provinceid = null;
          this.getBranches();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    saveBranch() {
      // console.log("this.selectedProvince.ID: " + this.selectedProvince.length)
      if (this.branchname === null || this.branchenname === null || this.selectedCountry === null || this.selectedProvince === null || this.selectedUser === null ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          branchname: this.branchname,
          branchenname: this.branchenname,
          countryid: this.selectedCountry.ID,
          provinceid: this.selectedProvince.ID,
          user: this.selectedUser.USERNAME,
          username: this.username
        };
        RestAPI.saveBranch(params)
          .then(res => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate branchname") {
              this.$swal(
                "ຊື່ສາຂາຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }

            if (res.data == "duplicate branchenname") {
              this.$swal(
                "ຊື່ສາຂາ(en)ຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }

            if (res.data == "duplicate province") {
              this.$swal(
               this.selectedProvince.NAME +" ມີສາຂາຢູ່ແລ້ວ",
                "-",
                "error"
              );
              return false;
            }
              
            this.$swal("ສ້າງສາຂາ ສຳເລັດ!", "", "success");
            
            this.branchname= null;
            this.branchenname= null;
            this.selectedCountry= null;
            this.selectedProvince= null;
            this.selectedUser= null;
            this.getBranches();
            this.activeTab = 1;
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getBranches() {
      RestAPI.getBranches()
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activebranches = res.data.activebranches;
          this.inactivebranches = res.data.inactivebranches;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    updateBranchForm(ID,NAME, ENNAME,COUNTRYID, COUNTRYNAME, PROVINCEID, PROVINCENAME, FULLNAME, USERNAME) {
     
      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.branchid = ID;
      this.oldbranchname =NAME;
      this.branchname = NAME;
      this.oldbranchenname =ENNAME;
      this.branchenname = ENNAME;
      this.countryid = COUNTRYID;
      this.provinceid = PROVINCEID;
      this.oldprovinceid = PROVINCEID;
      this.responseusername = USERNAME;
      this.oldresponseusername = USERNAME;
      this.selectedCountry ={"ID": COUNTRYID,"NAME": COUNTRYNAME};      
      this.selectedProvince ={"ID": PROVINCEID,"NAME": PROVINCENAME};
      this.selectedUser ={"USERNAME": USERNAME,"FULLNAME": FULLNAME};
      this.getResponseUser();
      
    },
    openSaveBranchForm() {
      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.branchname = null;
      this.branchenname = null;
      this.selectedCountry = null;
      this.selectedProvince = null;
      this.selectedUser = null;
    },
    updateBranch() {
      if (this.branchname === null || this.branchenname === null || this.selectedCountry === null || this.selectedProvince === null) {
      this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } 
      var params = {
        oldbranchname : this.oldbranchname,
        branchid: this.branchid,
        branchname: this.branchname,
        branchenname: this.branchenname,
        oldbranchenname: this.oldbranchenname,
        countryid : this.selectedCountry.ID,
        provinceid : this.selectedProvince.ID,
        oldprovinceid : this.oldprovinceid,
        responseusername : this.selectedUser.USERNAME,
        oldresponseusername : this.oldresponseusername,
        username: this.username
      };

      // console.log("pa: " + JSON.stringify(params))
     
      RestAPI.updateBranch(params)
        .then(res => {
          // console.log("data: "+ JSON.stringify(res.data))
          if (res.data == "duplicate branchname") {
            this.$swal(
              "ຊື່ສາຂາຊ້ຳ",
              "-",
              "error"
            );
            return false;
          }

          if (res.data == "duplicate branchenname") {
            this.$swal(
              "ຊື່ສາຂາ(EN)ຊ້ຳ",
              "-",
              "error"
            );
            return false;
          }

          if (res.data == "duplicate province") {
            this.$swal(
              this.selectedProvince.NAME +" ມີສາຂາຢູ່ແລ້ວ",
              "-",
              "error"
            );
            return false;
          }

          this.activeTab = 1;
          this.saveAction = true;
          this.updateAction = false;
          this.branchname = null;
          this.countryid = null;
          this.provinceid = null;
          this.getBranches();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    changeBranchSataus(branchid,status){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            branchid: branchid,
            status: status,
            username: this.username
          };
          RestAPI.changeBranchSataus(params)
            .then(() => {
            
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getBranches();

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },
    // splitBranchProvince(listofbranchprovince){
    //   if (typeof listofbranchprovince === 'string') {
    //     return listofbranchprovince.split(',');
    //   }else{
    //     return "ບໍ່ພົບ";
    //   }
    // },

    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getBranches();
    this.getCountry();
    this.getResponseUser();
    this.getAllProvince();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
